export const getRandomLetters = (length = 10) =>
  Array(length)
    .fill("")
    .map((e) => String.fromCharCode(Math.floor(Math.random() * 26) + 65))
    .join("");
